import React, { useEffect, useRef, useState } from "react";
import Card from "../Card";
import { HiOutlineVideoCamera } from "react-icons/hi"; // Changed icon
import { RiDeleteBin2Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import GalleryLogo from "../../assest/gallery.png";
import { IconChevronsLeft } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import {
    createVideoGalleryAlbum,
    getVideoGalleryAlbumData,
    addVideoData, 
    deleteVideoData, 
    deleteVideoAlbumData,
} from "../../controllers/galleryManagement.controller";
import toast from "react-hot-toast";
import Page from "../../Components/Page";

const VideoGallery = () => {
    const [previewValues, setPreviewValues] = useState([]);
    const [videos, setVideos] = useState([]); // Changed state name
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedVideo, setSelectedVideo] = useState(null); // Changed state name and updated value
    const navigate = useNavigate();

    const [isAddModalOpen, setIsAddModalOpen] = useState(true);
    const [modalData, setModalData] = useState({ index: null, value: "" });
    const [data, setData] = useState([]);
    const [selectedAlbumId, setSelectedAlbumId] = useState(null);

    const [uploadedVideos, setUploadedVideos] = useState([]); // Changed state name

    const add_album_name_ref = useRef();

    const handleVideoUpload = async (e) => {
        const files = Array.from(e.target.files);
        console.log("files", files);

        for (const file of files) {
            const formData = new FormData();
            formData.append('album_id', selectedAlbumId);
            formData.append('file', file);  //'video'  //file

            try {
                // Replace with your actual API call to upload the video
                const res = await addVideoData(formData); // Use your API function
                if (res.status === 200) {
                    fetchTableData()
                    document.getElementById("modal-add-videos").close()
                    // const newVideo = {
                    //     file: file,
                    //     preview: URL.createObjectURL(file),
                    //     name: file.name,
                    // };
                    // setUploadedVideos((prevVideos) => [...prevVideos, newVideo]);
                    toast.success("Video uploaded successfully!");
                } else {
                    toast.error("Failed to upload video.");
                }
            } catch (error) {
                console.error("Error uploading video:", error);
                toast.error("Error uploading video.");
            }
        }
    };

    const handleDeleteVideo = async (index) => {
        const videoToDelete = uploadedVideos[index];

        try {
            // Replace with your actual API call to delete the video
            const res = await deleteVideoData({ id: videoToDelete.video_id }); // Replace with the correct ID
            if (res.status === 200) {
                const updatedVideos = [...uploadedVideos];
                updatedVideos.splice(index, 1);
                setUploadedVideos(updatedVideos);
                toast.success("Video deleted successfully!");
            } else {
                toast.error("Failed to delete video.");
            }
        } catch (error) {
            console.error("Error deleting video:", error);
            toast.error("Error deleting video.");
        }
    };

    const handlePreviewChange = (index, field, value) => {
        const updatedValues = [...previewValues];
        updatedValues[index][field] = value;
        setPreviewValues(updatedValues);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    const handleAddVideos = (e) => {
        e.preventDefault();
    };

    const handleVideoChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setVideos(URL.createObjectURL(file));
        }
    };

    const fetchTableData = async () => {
        try {
            const res = await getVideoGalleryAlbumData();
            console.log("res => ", res);

            if (res.status === 200) {
                setData(res.data.data);
            }
        } catch (error) {
            console.error("Error fetching album data:", error);
            toast.error("Error fetching album data.");
        }
    };

    useEffect(() => {
        fetchTableData();
    }, []);

    const createAlbum = async () => {
        try {
            const album_name = add_album_name_ref.current.value;
            toast.loading("Please wait");
            const res = await createVideoGalleryAlbum({ album_name });
            const message = res.data.message;
            toast.dismiss();
            if (res.status === 200) {
                toast.success(message);
                add_album_name_ref.current.value = "";
                fetchTableData();
            } else {
                toast.error(message);
            }
        } catch (error) {
            console.log(error);
            const message =
                error?.response?.data?.message || "Something went wrong";
            toast.dismiss();
            toast.error(message);
        }
    };

    const deleteAlbum = async (album_id) => {
        try {
            toast.loading("Please wait");
            const res = await deleteVideoAlbumData({ id: album_id });
            const message = res.data.message;
            toast.dismiss();
            if (res.status === 200) {
                toast.success(message);
                fetchTableData();
            } else {
                toast.error(message);
            }
        } catch (error) {
            console.log(error);
            const message =
                error?.response?.data?.message || "Something went wrong";
            toast.dismiss();
            toast.error(message);
        }
    };

    useEffect(() => {
        if (selectedAlbumId)
            setUploadedVideos(
                data?.find((d) => d?.album_id === selectedAlbumId)?.videos || []
            );
        else setUploadedVideos([]);
    }, [selectedAlbumId, data]);

    const handleRemoveVideo = () => {
        setVideos(null); // Reset the video state
    };

    return (
        <>
            <Page className="px-8 py-6">
                <div>
                    <div className="max-w-6xl p-6 mx-auto bg-gray-100 rounded-lg shadow-md">
                        <div className="flex items-center mb-6 space-x-2 text-3xl text-gray-500">
                            <span>Gallery & News</span>
                            <span>/</span>
                            <span className="text-black">Video Gallery</span>
                        </div>

                        <div className="p-6 mb-10 bg-white rounded-lg shadow-md">
                            <h1 className="mb-4 text-xl font-bold text-gray-700">
                                Create Video Album
                            </h1>
                            <div className="mb-4">
                                <label className="block mb-2 text-gray-600">
                                    Add Album Name
                                </label>
                            </div>
                            <div className="flex gap-4">
                                <input
                                    ref={add_album_name_ref}
                                    type="text"
                                    className="w-[200px] px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:[#92288C]"
                                />
                                <button
                                    onClick={() => {
                                        createAlbum();
                                    }}
                                    className="bg-[#92288C] text-white py-2 px-4 rounded-lg hover:bg-[#92288C] focus:outline-none focus:ring-2 w-[150px] h-100"
                                >
                                    Create Album
                                </button>
                            </div>
                        </div>

                        <div className="p-6 bg-white rounded-lg shadow-md">
                            <h2 className="mb-4 text-xl font-bold text-gray-700">
                                Albums
                            </h2>
                            <form>
                                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                                    {data.map((d, i) => (
                                        <div
                                            key={`video-card-${i}`}
                                            className="p-4 bg-white rounded-lg shadow-md"
                                        >
                                            <h1 className="text-lg font-bold text-gray-800">
                                                {d.album_name}
                                            </h1>
                                            {/* <img
                                                src={d.videos.length > 0 ? d.videos[0]?.video_url : GalleryLogo}
                                                alt="GalleryLogo"
                                                className="object-cover w-full h-40 mb-4 rounded-lg"
                                            /> */}

                                            {d.videos.length > 0 ? (
                                                <video
                                                    src={d.videos[0]?.video_url}
                                                    alt="Video Preview"
                                                    className="object-cover w-full h-40 mb-4 rounded-lg"
                                                    controls // Add controls for playback
                                                />
                                            ) : (
                                                <img
                                                    src={GalleryLogo}
                                                    alt="GalleryLogo"
                                                    className="object-cover w-full h-40 mb-4 rounded-lg"
                                                />
                                            )}

                                            <div className="flex items-center justify-center w-8 h-8 rounded-md">
                                                <HiOutlineVideoCamera className="text-[#92288C]" />
                                            </div>

                                            <h1 className="text-lg font-bold text-gray-800">
                                                Videos Count {d.videos.length}
                                            </h1>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setIsDeleteModalOpen(true);
                                                    setSelectedAlbumId(d.album_id);
                                                }}
                                                className="px-3 py-1 w-full text-center bg-[#A8AAAE14] text-[#A8AAAE] border border-[#A8AAAE] rounded-md hover:bg-gray-300 mt-5"
                                            >
                                                Delete Album
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setSelectedAlbumId(d.album_id);
                                                    document
                                                        .getElementById("modal-add-videos")
                                                        .showModal();
                                                }}
                                                className="bg-[#92288C] text-white py-2 px-4 rounded-lg hover:bg-[#75006F] focus:outline-none focus:ring-2 w-full mt-5"
                                            >
                                                Add Videos
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </form>

                            {isDeleteModalOpen && (
                                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-25">
                                    <div className="w-full max-w-lg p-6 mx-auto bg-white rounded-lg shadow-lg">
                                        <div className="text-center">
                                            <h2 className="text-xl font-bold text-gray-900">
                                                Delete
                                            </h2>
                                            <p className="font-bold text-gray-500">
                                                Are you sure You want to delete this Album?
                                            </p>
                                            <p className="font-bold text-gray-500">
                                                {
                                                    data?.find(
                                                        (d) => d?.album_id === selectedAlbumId
                                                    )?.album_name
                                                }
                                            </p>
                                        </div>
                                        <div className="flex justify-center mt-4 space-x-4">
                                            <button
                                                onClick={() => setIsDeleteModalOpen(false)} // Close modal on "No"
                                                className="px-6 py-3 text-gray-600 transition bg-gray-200 rounded-lg hover:bg-gray-200 active:scale-95 hover:shadow-lg"
                                            >
                                                No
                                            </button>
                                            <button
                                                onClick={() => {
                                                    deleteAlbum(selectedAlbumId);
                                                    setIsDeleteModalOpen(false); // Simulate deletion and close modal
                                                }}
                                                className="rounded-lg transition active:scale-95 hover:shadow-lg px-6 py-3 bg-[#92288C] text-white"
                                            >
                                                Yes
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <dialog
                                id="modal-add-videos"
                                className="inset-0 z-50 rounded-lg modal modal-bottom xl:modal-middle w-96"
                            >
                                <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-75">
                                    <div className="p-6 bg-white rounded-lg shadow-lg">
                                        <h1 className="mb-4 text-lg font-bold">
                                            Add Videos
                                        </h1>

                                        <button
                                            onClick={() => {
                                                setSelectedAlbumId(null);
                                                document
                                                    .getElementById("modal-add-videos")
                                                    .close();
                                            }}
                                            className="text-[#92288C] flex items-center gap-2"
                                        >
                                            <IconChevronsLeft />
                                            Back
                                        </button>

                                        <div className="mb-4">
                                            <div className="flex flex-col items-center justify-center mt-2 border-2 border-gray-300 border-dashed rounded-lg h-36">
                                           
                                                {videos ? (
                                                    // <video
                                                    //     src={videos}
                                                    //     alt="Uploaded Preview"
                                                    //     className="object-contain w-auto h-28"
                                                    //     controls
                                                    // />
                                                    <div className="text-center text-gray-500">
                                                    <p>Select or drag and drop videos here</p>
                                                    <p className="text-sm text-center text-gray-400">
                                                          
                                                            </p>
                                                            <br>
                                                            </br>
                                                            <div className="items-center">
                                                    <input
                                                    type="file"
                                                    multiple
                                                    onChange={handleVideoUpload}
                                                    className="mb-4"
                                                    accept="video/*"
                                                />
                                                </div>
                                                </div>
                                                ) : (
                                                    <div className="text-center text-gray-500">
                                                        <p>Drag and drop video here</p>
                                                        <p className="text-sm text-center text-gray-400">
                                                            Any size of video, will automatically adjust to the frame
                                                        </p>
                                                        <label className="text-[#92288C] cursor-pointer">
                                                            <input
                                                                type="file"
                                                                accept="video/*"
                                                                onChange={handleVideoChange}
                                                                className="hidden"
                                                            />
                                                            Browse video
                                                        </label>
                                                        <input
                                            type="file"
                                            multiple
                                            onChange={handleVideoUpload}
                                            className="mb-4"
                                            accept="video/*"
                                        />
                                                        <button
                                                            onClick={handleRemoveVideo}
                                                            className="px-4 py-2 bg-white text-[#EA5455] rounded-md border-2 border-[#EA5455] hover:bg-[#EA5455] hover:text-white"
                                                        >
                                                            Remove video
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="p-6 bg-white rounded-lg shadow-md">
                                            <h2 className="mb-4 text-xl font-bold text-gray-700">
                                                Uploaded Videos
                                            </h2>
                                            <div className="overflow-y-auto max-h-60">  {/* Add scrollable container */}
                                                <table className="w-full border-collapse">
                                                    <thead>
                                                        <tr className="text-left text-gray-500 border-b">
                                                            <th className="px-4 py-2">
                                                                Preview
                                                            </th>
                                                            <th className="px-4 py-2">
                                                                File Name
                                                            </th>
                                                            <th className="px-4 py-2">
                                                                Actions
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {uploadedVideos.map(
                                                            (video, index) => (
                                                                <tr
                                                                    key={index}
                                                                    className="border-b"
                                                                >
                                                                    <td className="px-4 py-2">
                                                                        <video
                                                                            src={video.video_url}
                                                                            alt={video.video_path}
                                                                            className="object-cover w-32 h-24 rounded-lg"
                                                                            controls
                                                                        />
                                                                    </td>
                                                                    <td className="px-4 py-2">
                                                                        {video.video_path}
                                                                    </td>
                                                                    <td className="px-4 py-2">
                                                                        <button
                                                                            onClick={() =>
                                                                                handleDeleteVideo(
                                                                                    index
                                                                                )
                                                                            }
                                                                            className="flex items-center px-3 py-1 bg-[#A8AAAE14] text-[#A8AAAE] border border-[#A8AAAE] rounded-md hover:bg-gray-300"
                                                                        >
                                                                            Delete
                                                                            <RiDeleteBin2Line className="ml-2" />
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                        {uploadedVideos.length ===
                                                            0 && (
                                                                <tr>
                                                                    <td
                                                                        colSpan="3"
                                                                        className="py-4 text-center text-gray-500"
                                                                    >
                                                                        No videos
                                                                        uploaded.
                                                                    </td>
                                                                </tr>
                                                            )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                      
                                    </div>
                                </div>
                            </dialog>
                        </div>
                    </div>
                </div>
            </Page>
        </>
    );
};

export default VideoGallery;